export default {
  getStyle: (state) => state.style,
  getCenter: (state) => state.center,
  getZoom: (state) => state.zoom,
  getDefaultPosition: (state) => state.defaultPosition,
  getVesselCategories: (state) => state.vessel_categories,
  getPlotCategories: (state) => state.plot_categories,
  getCenterForGrid: (state) => (mapId) => {
    const defaultCenter = {
      lat: state.defaultPosition.lat,
      lng: state.defaultPosition.lng,
    };
    if (state.centerForGrid.length === 0) {
      return defaultCenter;
    }
    const targetGrid = state.centerForGrid.find((c) => c.mapId === mapId);
    if (!targetGrid || !targetGrid.center) {
      return defaultCenter;
    }
    return targetGrid.center;
  },
  getZoomForGrid: (state) => (mapId) => {
    const defaultZoom = state.defaultPosition.zoom;
    if (state.zoomForGrid.length === 0) {
      return defaultZoom;
    }
    const targetGrid = state.zoomForGrid.find((z) => z.mapId === mapId);
    if (!targetGrid || !targetGrid.zoom) {
      return defaultZoom;
    }
    return targetGrid.zoom;
  },
};
